import Resource from '@/plugins/sdk/Resource'
import { NUMBER, DATETIME, STRING } from '@/plugins/sdk/fields'

export default class extends Resource {
  static name = 'error_log'

  static get fields () {
    return {
      err_id: new NUMBER(),
      err_datetime: new STRING(),
      err_type: new STRING(),
      err_link_pk: new STRING(),
      err_message_id: new STRING(),
      err_message_values: new STRING(),
      err_verbose: new STRING(),
      created_at: new DATETIME(),
      updated_at: new DATETIME(),
      deleted_at: new DATETIME()
    }
  }
}
